import * as React from 'react';

export default function LoadingIndicator() {
  return <span className="loading-indicator">&#8635;</span>;
}
